function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 206 150"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: ".18",
  d: "M111.06 18.77c-18.66 3-37.66 3.02-56.47 4.83-9.73.93-64.27 28.6-53.1 87.43 4.1 21.67 25.82 39.24 47.86 38.28 18.72-.82 20.78-13.16 54.14-13.86 25.33-.53 44.86 17.55 74.2 7.11 13.01-4.62 23.38-16.29 26.7-29.68 3.32-13.4-1.5-28.87-12.83-36.77-5.88-4.11-13.38-6.34-17.57-12.17-8.2-11.43 8.41-29.11 1.02-41.08-14.69-23.81-48.3-6.6-63.95-4.09z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".05",
  d: "M36.39 112.54s-19.71 4.9-2.65 11.96c17.07 7.07 96.29 14.86 125.3-1.11 0 0 19.88-.56 20.43-3.35.54-2.79-2.36-5.04-2.36-5.04l-10.1-.34s-1.85 4.02-11.14-3.29c-9.3-7.3-119.48 1.17-119.48 1.17z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M177.5 116.73a6.7 6.7 0 01-4.86 2.54c-2.64 0-1.36-2.47-.5-2.47.25 0 .5-.02.74-.07l1.08-.95 1.08-.96.28-.6s1.5.34 1.76-.06l.2 1.68v.33c.11.16.19.36.21.56z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M156.54 112.58c0 8.6-26.8 15.58-59.87 15.58-33.07 0-59.88-6.98-59.88-15.58a4.85 4.85 0 011-2.84C42.92 102.5 67.33 97 96.67 97c29.34 0 53.75 5.49 58.88 12.74.62.82.97 1.81 1 2.84z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".05",
  d: "M155.13 109.74C150 117 125.6 122.47 96.25 122.47c-29.33 0-53.74-5.48-58.88-12.73C42.5 102.5 66.91 97 96.25 97c29.35 0 53.75 5.5 58.88 12.74z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".05",
  d: "M96.42 116.74c27 0 48.9-4 48.9-8.92s-21.9-8.91-48.9-8.91-48.9 3.99-48.9 8.91c0 4.93 21.9 8.92 48.9 8.92z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.68 106.9s3.43 7.5-40.65 7.79h-2.55c-11.75 0-20.25-.62-26.4-1.5h-.02c-15.73-2.24-16.03-6.27-16.03-6.27L24.6 1.33l45.64-.18L165.4.78 138.68 106.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M171.01 116.6c0 .25-2.64 1.76-5.23 1.76-2.6 0-1.37-2.49-.49-2.47h.88l.5-.25 1.9-.97.28-.6s1.5.34 1.76-.06l.2 1.71v.31c.11.17.18.37.2.57z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M170.83 116.03c.1.18.14.38.14.58 0 .25-2.65 1.76-5.24 1.76-2.59 0-1.36-2.5-.48-2.47h.88l.5-.25 4.16.07.04.31z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M167.19 117.41c-.64.17-1.3.17-1.94 0-.58-.31-.77-.55-.75-.8.02-.24.37-.95 1.76-.61 1.4.33 1.65 1.08 1.65 1.08l-.72.33zM177.5 116.73a6.71 6.71 0 01-4.86 2.54c-2.64 0-1.36-2.47-.5-2.47.25 0 .5-.02.74-.07l1.08-.95 3.34.06v.33c.11.17.18.36.2.56z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M174.11 118.2c-.63.16-1.3.16-1.94 0-.58-.32-.76-.56-.74-.8.02-.25.37-.96 1.76-.62 1.4.34 1.68 1.05 1.68 1.05l-.76.37z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M165.6 87.9l2.64 26.1s1.76.64 2.54 0l1.1-20.55 3.09 20.74s1.44.93 2.33-.12l1.15-26.3s-9.22 1.9-12.85.13z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M165.6 87.68l2.64 26.1s1.76.64 2.54 0l1.1-20.55 3.09 20.73s1.44.93 2.33-.13l1.15-26.3s-9.22 1.91-12.85.15z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M174.85 63.2c.35.28.72.52 1.11.71.93.54 1.94.91 3 1.11 1.38.15 1.96 2.75 2.14 3.96.19 1.22 1.45 7.28 1.45 7.28a2.46 2.46 0 01-1.95 2.6c-2.24.73-2.19 1.09-2.19 1.09l.05 7.78s-10.1 2.45-12.84.14l.4-10.53 1.5-11.44 4.28-1.99 3.05-.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M174.85 63.2c.35.28.72.52 1.11.71.93.54 1.94.91 3 1.11 1.38.15 1.96 2.75 2.14 3.96.19 1.22 1.45 7.28 1.45 7.28a2.46 2.46 0 01-1.95 2.6c-2.24.73-2.19 1.09-2.19 1.09l.05 7.78s-10.1 2.45-12.84.14l.4-10.53 1.5-11.44 4.28-1.99 3.05-.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M174.87 62.98a2.64 2.64 0 01-3.5 1.28l-.11-.05s-2.19 3.8.94 3.35c1.66-.25 2.74-2.87 3-4.11l-.33-.47z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".05",
  d: "M175.58 76.05c.82-.19 1.62-.43 2.4-.71.28-.18-.39-5.15-.39-5.15s-.25 3.99-5.35 5.9c-2.5.93 1.7 2.2 1.7 2.2l1.64-2.24z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".05",
  d: "M175.09 79.32s2.76 1.02 3.3.66v6.07s-7.04-4.57-7.04-5.28c0-.72-5.4-.88-5.4-.88v-1.66l8.19-.97s1.77-1.54.95 2.06z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.56 75.96s0 2.5-.38 3.2c-.38.72-.62-1.75-.62-1.75l1-1.45z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.03 59.95l-.07 1.3c-.04.61-.08 1.35-.1 1.96a4.13 4.13 0 01-1.27 2.76c-.44.45-.96.8-1.54 1.05a.82.82 0 01-1.04-.5.85.85 0 01-.02-.48 5.7 5.7 0 00.16-3.01c-.47-1.2 3.37-2.87 3.82-3.06l.06-.02z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M174.99 59.96c-.2.56-.25 1.66-1.1 2.74-.37.5-1.4 1.63-2.62 1.9a5.33 5.33 0 00-.12-1.57c-.46-1.18 3.38-2.87 3.84-3.07z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M171.23 52.52a4.17 4.17 0 00-3.93 4.69c.13 1.7.57 3.35 1.29 4.89 1.37 2.32 4.81.4 5.36-.55.54-.96 2.64-5.28 1.76-6.5-.58-.8-2.24-2.62-4.48-2.53z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M167.58 50.9l.7.36a2.65 2.65 0 00-2.17 1.02 3.51 3.51 0 00-1.02 2.43l1.2-.57s-.08 1.47 2.2 1.59c2.27.11 4.68.2 4.68.2l-.77-1.06s1.43.57 1.66 1.09c.22.83.38 1.68.48 2.54 0 0 .57-1.45.79-1.13.22.31-.25 1.63-.55 1.93-.3.3-.25 1.17-.27 1.23-.03.07 1.4-1.11 1.48-1.52.07-.4 1.5-4.55.57-5.4l.57-.05a2.74 2.74 0 00-1.11-.44s-3.75-4.89-8.44-2.22z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M167.51 65.97s-1.76.77-1.99 4.23c-.19 2.24-.6 4.45-1.23 6.6-1.33.14-2.67.2-4.01.2l1.96 1.5c.73.56 1.58.94 2.49 1.11l1.35.3 1.43-13.94z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M174.05 77.86v.1a.72.72 0 01-.75.63l-13.2-.75a.69.69 0 01-.33-.1.7.7 0 01-.38-.39l-2.89-8.22a.72.72 0 01.7-.96l9.17.16a.72.72 0 01.68.53l2 7.21a.73.73 0 00.6.52l3.75.56a.72.72 0 01.65.71z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M174.05 77.86v.1a.72.72 0 01-.75.63l-13.2-.75a.69.69 0 01-.33-.1.7.7 0 01-.38-.39l-2.89-8.22a.72.72 0 01.7-.96l9.17.16a.72.72 0 01.68.53l2 7.21a.73.73 0 00.6.52l3.75.56a.72.72 0 01.65.71z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.46 77.45a1 1 0 01-.65 0 2.56 2.56 0 01-.63-.22c-.36-.2-1.15-.92-1.89-.71-.65.16-1.33.2-2 .1-.26-.06-.26-.13-.53-.1-.26.03-.25-.32-.25-.32.8-.51 1.66-.92 2.56-1.22.9.03 1.8.2 2.65.54l.57.33.03.02.31.18s.02 1.26-.17 1.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M172.78 75l-1.22-.66s-.2.33-.08.5c.06.09.14.16.22.23.35-.1.72-.12 1.08-.07z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.47 78.03c.46.6 1.1 1.05 1.84 1.25 1.32.42 3.69-.45 3.69-.45s.77-.35.63-.43c-.14-.08-3.95-.23-3.95-.23l-2.2-.14z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M166.17 115.9s.89.44.94 1.13l.07.38s3.3-.63 3.68-1.38l-.16-1.16a1.71 1.71 0 01-1.51.54c-.78-.23-.64-.74-.64-.74l-2.38 1.22zM173.18 116.89l-.3-.16 2.17-1.92s.46 1.13 2.1.22l.2 1.13a7.58 7.58 0 01-3.46 2.08 1.74 1.74 0 00-.71-1.35z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".61",
  d: "M166.17 115.9s.89.44.94 1.13l.07.38s3.3-.63 3.68-1.38l-.16-1.16a1.71 1.71 0 01-1.51.54c-.78-.23-.64-.74-.64-.74l-2.38 1.22z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".61",
  d: "M173.18 116.89l-.3-.16 2.17-1.92s.46 1.13 2.1.22l.2 1.13a7.58 7.58 0 01-3.46 2.08 1.74 1.74 0 00-.71-1.35z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169.36 78.23l-4.99-.27-4.67-.25a.72.72 0 01-.32-.37l-.28-.82-1.03-2.93-1.55-4.45a.76.76 0 01.12-.25l4.59.06 4.85.07a.56.56 0 01.5.48c.07.46 2 7.8 2 7.8a1.46 1.46 0 00.78.93z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".05",
  d: "M169.36 78.23l-4.99-.27-4.67-.25a.72.72 0 01-.32-.37l-.28-.82-1.03-2.93-1.55-4.45a.76.76 0 01.12-.25l4.59.06 4.85.07a.56.56 0 01.5.48c.07.46 2 7.8 2 7.8a1.46 1.46 0 00.78.93z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".05",
  d: "M169.34 76.75s.62 1.36 0 1.47l4.01.17s.44-.1.4-.43c-.07-.25-.2-.48-.4-.65l-3.83-.5-.18-.06z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169.32 77.95c.1-.02.14-.2.1-.4-.05-.21-.17-.36-.26-.34-.09.02-.13.2-.09.41.05.2.16.35.25.33z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M168.56 78.23l-4.05-.17-4.67-.25a.7.7 0 01-.33-.38l-.28-.82 8.66.2c.11.52.34 1 .67 1.42z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M170.48 89.18s.43 3.52 1.4 4.25l-.3-4.13-1.1-.12zM176.71 88.1l.41 26.05 1.32-26.42-1.73.37z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.78 104.92l-.13.1-.32.24c-.34.29-.66.6-.97.91-.89.96-1.42 1.91-1.43 2.83 0 .41.12.82.34 1.17l.02-.18-1.44 1.39-.12.1.12.11 3.52 3.17.07.06.08-.04 4.19-1.76h-.1l.07.04.2.08.75.32a92.37 92.37 0 003.23 1.25c1.6.59 2.84.96 3.58 1.06l-.12-.19-1.86 5.85-.04.14.13.05 3.2 1.11-.1-.13.05 1.67h.3l-.05-1.67v-.1l-.1-.03-3.2-1.12.1.18 1.86-5.85.05-.16-.17-.03c-.71-.09-1.94-.46-3.52-1.04l-.82-.3c-.8-.3-1.61-.63-2.4-.95l-.75-.31-.2-.1-.07-.02-.06-.03-.06.03-4.18 1.76.15.02-3.52-3.16v.22l1.44-1.4.09-.07-.07-.1c-.2-.3-.3-.66-.3-1.02 0-.82.5-1.72 1.36-2.62a10.52 10.52 0 011.25-1.14l.12-.09-.17-.25zM58.04 118.37l.19.03.53.08a445.14 445.14 0 0011.33 1.62c4.8.6 8.41.94 10.4.91h.1l.04-.09 1-2.41-.15.09h.08l.23.02.84.05 2.78.16 2.25.12c2.23.1 3.97.14 5.04.11l-.15-.13.47 6.95v.15h.77l1.68-.03c1.75-.03 3.48-.06 5.1-.12 4.06-.13 6.7-.32 7.33-.6l.1-.04v-.1l-.2-2.8-.05.14 4.92-3.24-.07.02h.13l.4-.03 1.36-.1c1.43-.12 2.85-.25 4.18-.4 2.83-.3 4.83-.62 5.68-.95l-.2-.1.72 2.82.02.08.08.03 8.18 2.32h.07l6.88-1.5-.12-.02 1.5 1.2.18-.22-1.5-1.21-.05-.05-.07.02-6.88 1.5h.08l-8.19-2.33.1.1-.71-2.84-.04-.17-.16.06c-.81.32-2.8.64-5.6.95a148.63 148.63 0 01-5.54.5l-.38.02h-.14l-.07.03-4.93 3.24-.07.04v.09l.18 2.79.1-.15c-.6.25-3.25.45-7.24.58-1.62.06-3.35.1-5.09.12l-1.68.02h-.63l.15.14-.47-6.96v-.14h-.11a79 79 0 01-5.03-.12 233.28 233.28 0 01-5.02-.27l-.84-.06-.23-.01h-.19l-.03.1-1 2.4.13-.09c-1.97.04-5.59-.3-10.36-.9a317.14 317.14 0 01-9.39-1.32l-1.94-.3-.53-.09-.18-.02-.07.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.55 127.92l-2.94-3.91-.05-.07h-.07c-1.06.12-4.61-.1-9.84-.58l-2.2-.21a675.2 675.2 0 01-5.6-.57l-1.75-.18-.48-.05-.17-.02h-.06l-.04.03-3.3 2.4.18.23 3.29-2.38-.1.03.16.02.48.05 1.75.19c1.83.2 3.74.38 5.6.56l2.2.21c5.27.48 8.82.71 9.9.58l-.13-.06 2.94 3.91.23-.18zM150.79 118.97l.06-3.03-.08.13.16-.1.42-.26c.45-.3.87-.63 1.26-1a5.27 5.27 0 001.83-3.16l-.13.13 1.61-.13-.02-.29-1.61.12h-.12l-.02.12a4.97 4.97 0 01-1.74 3 9.62 9.62 0 01-1.78 1.3l-.08.03v.1l-.06 3.04h.3zM48.14 103.12l-.16.1-.4.28c-.43.32-.84.68-1.22 1.06-1.46 1.48-2.15 3.1-1.62 4.8l.28-.08c-.49-1.58.16-3.1 1.55-4.5a9.9 9.9 0 011.73-1.4l-.16-.26zM38.05 108.48c-.1.15-.17.3-.22.46-.3.86-.3 1.8.03 2.64.47 1.38 1.61 2.81 3.56 4.25a34.91 34.91 0 005.65 3.01l-.08-.09 1.01 3.17.28-.1-1-3.14-.03-.07-.06-.03a34.47 34.47 0 01-5.6-2.99c-1.9-1.4-3-2.78-3.45-4.1a3.56 3.56 0 01.1-2.74l.05-.1-.24-.17zM150.66 106.44l.05.06c.02.04.1.12.14.2a7 7 0 01.45.7c.58 1.08.81 2.18.5 3.2-.4 1.26-1.6 2.3-3.81 3.03a291.93 291.93 0 01-10.4 3.26l-.56.15-.2.05.15.04-2.1-2.05-.04-.05h-.08l-4.7.56.1.04-1.49-1.37-.2.22 1.5 1.36.05.05h.08l4.72-.56-.13-.03 2.1 2.04.06.06.08-.02.2-.05.55-.16 2.18-.64c2.38-.72 5.14-1.59 8.23-2.62 2.3-.76 3.57-1.86 3.98-3.22.34-1.11.1-2.28-.52-3.42a6.98 6.98 0 00-.68-1.03l-.21.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.46 77.45a1 1 0 01-.66 0c.61-.16.49-1.6.49-1.6l.03.02.31.18s.02 1.26-.17 1.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M170.82 91l-.7 23.22c.24 0 .47-.08.67-.21l1.1-20.58-1.07-2.42z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96.67 114.77l-18.83-.65c-.22-.01-5.38-.66-12.08-1.58-2.61-.35-11.9-3.12-12.72-5.62L24.6 1.33l45.64-.18L96.65 114.7l.02.08z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".13",
  d: "M161.22 68.96l-.16.36-2.64 4.56-.35-.28-1.55-4.46a.76.76 0 01.12-.25l4.58.07z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "95.54",
  y1: "114.7",
  x2: "94.99",
  y2: ".99",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".01",
  stopColor: "#fff",
  stopOpacity: ".4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#fff",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "151.8",
  y1: "106.28",
  x2: "187.59",
  y2: "96.46",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#68E1FD",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".02",
  stopColor: "#66DAF6",
  stopOpacity: ".04"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".18",
  stopColor: "#58A1BC",
  stopOpacity: ".39"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".35",
  stopColor: "#4D758F",
  stopOpacity: ".66"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".53",
  stopColor: "#45566F",
  stopOpacity: ".85"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".73",
  stopColor: "#40435C",
  stopOpacity: ".96"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".99",
  stopColor: "#3F3D56"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "172.8",
  y1: "76.03",
  x2: "148.1",
  y2: "77.15",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".91",
  stopOpacity: ".8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "170.96",
  y1: "63.51",
  x2: "175.03",
  y2: "63.51",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ECC4D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".42",
  stopColor: "#EFD4D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#F2EAC9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "2860.26",
  y1: "1985.09",
  x2: "2952.71",
  y2: "2308.09",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ECC4D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".42",
  stopColor: "#EFD4D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#F2EAC9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "5977.3",
  y1: "4344.76",
  x2: "6277.72",
  y2: "4344.76",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ECC4D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".42",
  stopColor: "#EFD4D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#F2EAC9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "11800.4",
  y1: "3579.6",
  x2: "11816.6",
  y2: "2833.93",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".91",
  stopOpacity: ".8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "4332.58",
  y1: "1273.37",
  x2: "4482.93",
  y2: "1273.37",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ECC4D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".42",
  stopColor: "#EFD4D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#F2EAC9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "1089.89",
  y1: "415.83",
  x2: "1097.05",
  y2: "415.83",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ECC4D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".42",
  stopColor: "#EFD4D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#F2EAC9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "4214.11",
  y1: "739.03",
  x2: "4367.15",
  y2: "739.03",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ECC4D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".42",
  stopColor: "#EFD4D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#F2EAC9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "169.57",
  y1: "117.52",
  x2: "167.75",
  y2: "114.08",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".36",
  stopColor: "#00272E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#69B9EB",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "3332",
  y1: "2321.64",
  x2: "3298.87",
  y2: "2270.5",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".36",
  stopColor: "#00272E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#69B9EB",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "754.21",
  y1: "861.16",
  x2: "772.96",
  y2: "886.64",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ECC4D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".42",
  stopColor: "#EFD4D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#F2EAC9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "17635.4",
  y1: "71648.7",
  x2: "17239.7",
  y2: "19787.8",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".01",
  stopColor: "#fff",
  stopOpacity: ".4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#fff",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "156.51",
  y1: "71.39",
  x2: "161.22",
  y2: "71.39",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#68E1FD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#69B9EB"
})), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("path", {
  transform: "translate(0 .78)",
  d: "M0 0h205.43v148.56H0z"
})))));